module.exports = __webpack_public_path__ + "img/f-thermometer-img8-1.5045fe0f.png";